var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const ErrorPage = ({ title, text }) => {
    var _a;
    const assetPath = (_a = window.STATIC_ASSETS_PATH) !== null && _a !== void 0 ? _a : './assets';
    return (_jsxs("div", { id: "errorPage", className: "error-page h-screen w-full flex items-center justify-center", children: [_jsx("div", { className: `error-app-bg absolute w-full h-full left-0 top-0 object-cover pointer-events-none bg-cover bg-center bg-no-repeat`, style: {
                    backgroundImage: `url("${assetPath}/imgs/app-banner.jpg")`,
                } }), _jsx("div", { className: "content relative z-20 text-center bg-white dark:bg-darkPrimary/90 rounded-xl shadow-lg h-80 w-[450px] flex items-center justify-center", children: _jsxs("div", { className: "inner text-center dark:text-darkText", children: [_jsx("h2", { className: "text-3xl font-medium mb-4", children: title }), _jsx("p", { children: text })] }) })] }));
};
_react_refresh_temp_1 = ErrorPage;
$RefreshReg$(_react_refresh_temp_1, "ErrorPage");
export default ErrorPage;
